import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import { useState, Fragment } from "react";
import Slider from "../../atoms/Slider";
import { Dialog, DialogContent } from "@material-ui/core";
import { useBoard } from "../../../providers/BoardDetailProvider";
import { CheckSpFlag } from "../../../hooks/CheckSpFlag";

const BoardBodySlider = () => {
  const {
    state: { boardDetailData },
  } = useBoard();

  const isSp = CheckSpFlag();
  const [src, setSrc] = useState<string>("");
  const handleCloseDialog = () => {
    setSrc("");
  };
  const handleOpenDialog = (srcImage: string) => {
    setSrc(srcImage);
  };

  const { image_urls = [] } = boardDetailData ?? {};

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };

  if (!Array.isArray(image_urls) || image_urls.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <Slider {...settings}>
        {Array.from({ length: 3 }).map((_, index: number) => {
          const src = image_urls[index];
          if (!src) {
            if (isSp) {
              return null;
            }
            return <div key={`${image_urls[index]}-${index}`} />;
          }

          return (
            <img
              src={image_urls[index]}
              key={`${image_urls[index]}-${index}`}
              alt={`board-${image_urls[index]}-${index}`}
              style={{ height: 120, cursor: "pointer" }}
              className={`${STBoardDetail.boardBodyImage} forum-board-image`}
              onClick={() => handleOpenDialog(image_urls[index])}
            />
          );
        })}
      </Slider>

      <Dialog open={!!src} onClose={handleCloseDialog}>
        <DialogContent className={STBoardDetail.imageContainer}>
          <img
            src={src}
            key={`${src}`}
            alt=""
            className={STBoardDetail.screenImage}
            onClick={() => handleCloseDialog()}
          />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default BoardBodySlider;
